<script setup lang="ts">
const store = useAudioStore()

const { isFullscreen, isPlaying, currentTime, tts } = storeToRefs(store)

const isLoading = computed(() => tts.value?.status === "loading")
</script>

<template>
  <div class="flex w-fit items-center justify-between gap-2">
    <UButton
      aria-label="Hopp 15 sekunder tilbake"
      variant="quite"
      theme="white"
      class="scale-75 hover:text-lighter"
      :class="{ 'hidden lg:block': !isFullscreen }"
      :disabled="isLoading"
      @click="currentTime -= 15"
    >
      <UIcon name="skip-15-back" size="xl" />
    </UButton>
    <UButton
      :aria-label="isPlaying ? 'Sett på pause' : 'Spill av'"
      theme="white"
      circle
      :disabled="isLoading"
      :data-pendo="`audio-player-active-${isPlaying ? 'pause' : 'play'}-${tts.status !== 'disabled' ? '-tts' : ''}`"
      class="hover:!bg-transparent"
      @click="store.togglePlayState()"
    >
      <UIcon :name="isPlaying ? 'pause' : 'play-filled'" />
    </UButton>
    <UButton
      aria-label="Hopp 15 sekunder fremover"
      variant="quite"
      theme="white"
      class="scale-75 hover:text-lighter"
      :class="{ 'hidden lg:block': !isFullscreen }"
      :disabled="isLoading"
      @click="currentTime += 15"
    >
      <UIcon name="skip-15-forward" size="xl" />
    </UButton>
  </div>
</template>
